import React from 'react';
import {
  Button,
  Popup,
  Icon,
} from 'semantic-ui-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { encodeQuery } from '../searchHelper';

const CopySearchUrl = ({ query, filter }) => {
  const intl = useIntl();
  return (
    <Popup
      content={intl.formatMessage({ id: 'search.input.copy' })}
      trigger={(
        <CopyToClipboard text={encodeQuery(query, filter)}>
          <Button
            className="aridhia-copy-search-url primary"
            disabled={!hasMinimumLength(query)}
          >
            <Icon name="copy outline" className="aridhia-copy-search-url primary" />
          </Button>
        </CopyToClipboard>
      )}
    />
  );
};

export default CopySearchUrl;
